import { QueryClient } from "vue-query";

export const queryClient = new QueryClient();
